const faqItems = [
  {
    id: 1,
    q: '51每日大赛是什么平台？',
    a: '51每日大赛是国内领先的吃瓜爆料内容聚集平台，每日更新娱乐圈、直播圈、网红圈、体育圈等各领域的热门事件和深度爆料。平台提供Web端和移动端（iOS/Android）访问方式，所有内容免费浏览。',
  },
  {
    id: 2,
    q: '平台的内容来源可靠吗？',
    a: '我们的内容主要来源于公开媒体报道、社交平台热议话题以及网友投稿。对于网友投稿内容，编辑团队会进行多方交叉验证后再发布，确保信息的真实性和准确性。同时平台坚持客观呈现事实，不做主观引导和评判。',
  },
  {
    id: 3,
    q: '如何下载51每日大赛APP？',
    a: '您可以在Apple App Store搜索"51每日大赛"下载iOS版本，或在各大安卓应用商店搜索下载Android版本。APP支持消息推送功能，确保您第一时间收到最新爆料通知。请认准官方渠道下载，谨防山寨应用。',
  },
  {
    id: 4,
    q: '如何投稿爆料？',
    a: '您可以通过以下方式投稿：1）发送邮件至 tips@51daily.news；2）添加微信客服 51dailytips；3）在网站的"投稿爆料"模块填写在线表单。我们承诺对所有投稿人信息严格保密，内容一经采用将根据热度给予相应奖励。',
  },
  {
    id: 5,
    q: '网站访问不了怎么办？',
    a: '如果遇到网站无法访问的情况，您可以通过以下方式获取最新入口：1）关注我们的官方社交媒体账号获取最新地址；2）下载APP获得更稳定的访问体验；3）发送邮件至客服邮箱获取帮助。建议收藏多个访问方式，以防万一。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于51每日大赛的常见疑问解答</p>
        </div>

        <div className="max-w-3xl space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="text-accent-500 flex-shrink-0">Q:</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}